/**
 * Parses API error messages and returns user-friendly error messages in Danish.
 * Detailed technical errors are logged to console for debugging but never displayed to users.
 *
 * Handles the following error types:
 * - HTTP status codes (400, 401, 403, 404, 500, 502, 503, 504)
 * - Network errors (Failed to fetch, NetworkError)
 * - Generic API errors
 * - Unknown error types (fallback to generic message)
 *
 * @param error - Error object or unknown type to parse
 * @returns User-friendly error message in Danish
 *
 * @example
 * parseApiError(new Error("API error 404"))
 * parseApiError(new Error("Failed to fetch"))
 */
export function parseApiError(error: unknown): string {
  console.error("Full API Error (console only):", error);

  if (error instanceof Error) {
    const errorMessage = error.message;

    if (errorMessage.includes("API error 404")) {
      return "Ressource ikke fundet.";
    }
    if (errorMessage.includes("API error 401") || errorMessage.includes("API error 403")) {
      return "Du har ikke tilladelse til at se denne side.";
    }
    if (errorMessage.includes("API error 500")) {
      return "Server fejl. Prøv igen senere eller kontakt support.";
    }
    if (errorMessage.includes("API error 400")) {
      return "Ugyldig anmodning. Tjek dine indtastninger.";
    }
    if (errorMessage.includes("API error")) {
      return "Der opstod en fejl. Prøv igen eller kontakt support.";
    }

    if (errorMessage.includes("Failed to fetch") || errorMessage.includes("NetworkError")) {
      return "Kunne ikke oprette forbindelse til serveren. Tjek din internetforbindelse.";
    }

    return "Der opstod en uventet fejl. Prøv igen.";
  }

  return "Der opstod en uventet fejl. Prøv igen.";
}
